import { Routes } from '@angular/router';
import { redirectPartnerRegistrationToken } from './partner-registration-route.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'sign-up', pathMatch: 'full' },
  {
    path: 'sign-up',
    children: [
      { path: '', redirectTo: '/welcoming', pathMatch: 'full' },
      {
        path: 'registration',
        canActivate: [redirectPartnerRegistrationToken],
        loadComponent: () => import('./sign-up-v2/sign-up-v2.component').then(m => m.SignUpV2Component)
      },
      {
        path: 'partner-registration',
        loadComponent: () =>
          import('./sign-up-special-v2/sign-up-special-v2.component').then(m => m.SignUpSpecialV2Component)
      },
      {
        path: 'partner-application',
        loadComponent: () =>
          import('./partner-application/partner-application.component').then(m => m.PartnerApplicationComponent)
      },
      {
        path: 'thx-for-application',
        loadComponent: () =>
          import('./thx-for-application/thx-for-application.component').then(m => m.ThxForApplicationComponent)
      },
      {
        path: 'us',
        loadComponent: () => import('./sign-up-v2/sign-up-v2.component').then(m => m.SignUpV2Component)
      },
      {
        path: 'us/:code',
        loadComponent: () => import('./sign-up-v2/sign-up-v2.component').then(m => m.SignUpV2Component)
      },
      {
        path: 'mexican',
        loadComponent: () => import('./sign-up-v2/sign-up-v2.component').then(m => m.SignUpV2Component)
      },
      {
        path: 'mexican/:code',
        loadComponent: () => import('./sign-up-v2/sign-up-v2.component').then(m => m.SignUpV2Component)
      }
    ]
  },
  {
    path: 'log-in',
    loadComponent: () => import('./login/login.component').then(m => m.LogInComponent)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
  },
  {
    path: 'reset-successful',
    loadComponent: () =>
      import('./forgot-password/password-reset-successful/password-reset-successful.component').then(
        m => m.ResetSuccessfulComponent
      )
  },
  {
    path: 'onboarding',
    children: [
      { path: '', redirectTo: 'welcome', pathMatch: 'full' },
      {
        path: 'welcome',
        loadComponent: () => import('./onboarding/welcome/welcome.component').then(m => m.WelcomeComponent)
      },
      {
        path: 'apply',
        loadComponent: () => import('./onboarding/apply/apply.component').then(m => m.ApplyComponent)
      },
      {
        path: 'experience',
        loadComponent: () =>
          import('./onboarding/unigana-experience/unigana-experience.component').then(m => m.UniganaExperienceComponent)
      },
      {
        path: 'journey',
        loadComponent: () =>
          import('./onboarding/start-journey/start-journey.component').then(m => m.StartJourneyComponent)
      }
    ]
  }
];
